import type { DropdownOption } from 'client/js/main/types/dropdownTypes';

export class DraggableCompareByService {
  public static addIndex(value: DropdownOption | DropdownOption[]) {
    if (Array.isArray(value)) {
      return value.map((option, index) => ({ ...option, index }));
    }

    return { ...value };
  }
}
